/**
 * Transforms a date string to a locale date string.
 *
 * ex: '2024-09-26T07:00:00.000Z' -> '9/26/2024'
 */
export function formatDateToLocaleString(date: string): string {
  if (Date.parse(date)) {
    return new Date(date).toLocaleDateString('en-US');
  }

  return date;
}

/**
 * Takes a time that is in UTC, and converts it to the local timezone with a locale string.
 *
 * ex: '2024-09-26T15:00:00.000Z' -> '9/26/2024, 8:00 AM'
 */
export function formatUTCDateTimeToLocaleString(utcDateString: string): string {
  const utcDate = new Date(utcDateString);
  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  };

  return utcDate.toLocaleString('en-US', options);
}

/**
 * formats a date for a file name
 *
 * ex: '2024-09-26T15:00:00.000Z' -> '10-29-2024 1-27 PM'
 */
export function formatDateTimeForFileName(date: string): string {
  const utcDate = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };

  const formattedDate = utcDate.toLocaleString('en-US', options);

  return formattedDate
    .replace(/\//g, '-') // replace slashes with dashes
    .replace(/, /g, ' ') // remove comma
    .replace(':', '-'); // replace colon in time with dash
}
